import React from 'react'
// components
import KPIPageAPI from 'containers/KPIs/Register/layers/API'
import TableManagementProvider from 'containers/Search/layers/BL'
import KPI from 'components/PageComponents/KPIs'

const KPIContainer: React.FC = () => (
  <TableManagementProvider>
    <KPIPageAPI>
      <KPI />
    </KPIPageAPI>
  </TableManagementProvider>
)

export default KPIContainer
